import {Locale} from '@aboutyou/config';
import {verifyAsCashOnDeliveryCountry} from '../utils/bank';

/**
 * Whether to show the bank data (COD) nav item in the account area.
 * Shown when COD is enabled for the locale, so users can add or view refund bank details.
 */
export const shouldShowBankData = (
  locale: Locale,
  enableRecurringPaymentMethodsRequest: boolean,
) => {
  return (
    enableRecurringPaymentMethodsRequest &&
    verifyAsCashOnDeliveryCountry(locale)
  );
};
